export const getAllIssues = state => state.issues.issues.allIssues;
export const getIsLoading = state => state.issues.issues.isLoading;
export const getError = state => state.issues.issues.error;

export const getUserRepo = state => state.issues.userRepo;
export const getColumns = state => state.issues.columns;
